import React, { Component } from 'react'
import { Link } from 'react-router-dom';
// import Security from '../../old_Components/Settings/Security'
import constant from '../../constant'
export default class Security extends Component {
  constructor() {
    super();
    this.state = {

    }
  }
  componentDidMount() {
    document.title = constant.title.Security
  }
  render() {
    return (
      <React.Fragment>
        <section className='pricing-area padding-bottom-80px'>
          <div className="container">
            <div className='row'>
              <div className='col-md-12'>
                <div className='setyoupinarea'>
                  <h3>{this.props.title}</h3>
                  <p>This PIN will be used for Post / Edit a Premium / Featured Jobs, View Jobs Applications & Perform Activity</p>

                  <div className='btn-setyoupin'>
                    <Link to={constant.component.updateSecurityCode.url}>{this.props.title}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }
}
